const Types = {
  DATE_CHANGE: '[DATE] CHANGE',
  DATE_STORE_CHANGE: '[DATE] STORE CHANGE'
};

export default Types;